// extracted by mini-css-extract-plugin
export default {"modalContent":"modalContent---KO3Z2","modalFooter":"modalFooter---D4j7P"};